import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getProjetos(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("projetos/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },    
    getProjetosBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("projetos/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getProjeto(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("projetos/access/obter", {ID_PROJETO: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteProjeto(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("projetos/access/excluir", {ID_PROJETO: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postProjeto(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("projetos/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getProjetosUsuarios(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("projetos/access/obterUsuarios", id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};